module.exports = __webpack_public_path__ + "img/offeo-2.0f337148.png";